import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import {
  PRICE_SCHEDULE_MODES,
  LEGACY_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./AccumulatorOverrideScheduleCriteriaFormConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";
import classes from "./css/AccumulatorOverrideScheduleCriteriaForm.module.css";

const screenInfo = {
  ADD: ["Add Accumulator Override Schedule Criteria", "RCAOC002"],
  CHANGE: ["Accumulator Override Schedule Criteria Detail", "RCAOC003"],
  VIEW: ["Accumulator Override Schedule Criteria Detail", "RCAOC003"],
};

const AccumulatorOverrideScheduleCriteriaForm = ({ mode }) => {
  const { axios_helper_no_header } = useAxios();

  const {
    ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
    EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA,
  } = ROUTE_PATHS;

  const location = useLocation();
  // const { selectedPriceSchedules = [],
  //   previousScreen = '/accumulator-overrride-schedule',
  //   currentIndex: initialIndex = 0,
  //   rowData} = location.state || {};

  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    selectedCriterias = [],
    previousScreen = ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    currentIndex: initialIndex = 0,
    paramsData,
    lookupParams,
    lookupScreen,
    formData: baseFormData = {},
    navigateData,
    lookupMode: initialLookupMode = false,
    currentMode: baseMode = mode,
    dataDrafted: initialDataDrafted = false,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(baseMode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [dataDrafted, setDataDrafted] = useState(initialDataDrafted);
  //const [looupMode, setLookupMode] = useState(initialLookupMode);
  const toast = useToast();
  /* const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce(
        (acc, item) => {
          acc[item["legacy"]] = formData[item["source"]];
          return acc;
        },
        { workInitialProgramMode: "DSP" }
      );
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };*/

  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialFormData,
    initialIndex,
    currentState,
    previousState,
    lookupScreen,
    initialLookupMode,
    lookupParams,
    navigateData,
    currentMode,
  });

  const handleBack = () => {
    if (currentIndex < selectedCriterias.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setInitialFormData({});
      setCurrentMode(mode);
      setDataDrafted(false);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/aocaccumovrdscdcriteria";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/aocaccumovrdscdcriteria";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];
    

    if (
      JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData) &&
      !dataDrafted
    ) {
      infoChanged = false;
    }
  }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
        toast.current.show({
          severity: "info",
          summary: "",
          detail: responseStatus.message,
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "success",
          summary: "",
          detail: responseStatus.message,
          life: 3000,
        });
      // setInitialFormData(responseData);
      // setLookupMode(false);
      setDataDrafted(false);
      if (isAddMode(currentMode)) {
        //  setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const latestCurrentState = {
          ...currentState,
          selectedCriterias: [{ ...responseData }],
          currentIndex: 0,
          lookupMode: false,
          currentMode: PRICE_SCHEDULE_MODES.EDIT,
        };
        navigateToPage(EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_CRITRIA, [
          ...previousState,
          latestCurrentState,
        ]);
      }
    }} catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      // keyFunc.Enter = submitForm;
      // keyName.Enter = 'Save';
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      //  keyFunc.Enter = submitForm;
      // keyName.Enter = 'Save';
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
        setLookupMode(false);
      };
      keyName.chmod = "View";

      if (
        paramsData.aosAccumOvrdScdeType === "D" ||
        paramsData.aosAccumOvrdScdeType === "O"
      ) {
        keyName.F7 = "State CSR Criteria";
        keyFunc.F7 = () => {
          navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_STATE, [
            ...previousState,
            { ...currentState, currentIndex },
            {
              selectedCriterias: [selectedCriterias[currentIndex]],
              previousScreen: location.pathname,
              currentIndex: 0,
              paramsData,
            },
          ]);
        };
      }
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        setLookupMode(false);
      };
      keyName.chmod = "Edit";

      if (
        paramsData.aosAccumOvrdScdeType === "D" ||
        paramsData.aosAccumOvrdScdeType === "O"
      ) {
        keyName.F7 = "State CSR Criteria";
        keyFunc.F7 = () => {
          navigateToPage(ACCUMULATOR_OVERRIDE_SCHEDULE_STATE, [
            ...previousState,
            { ...currentState, currentIndex },
            {
              selectedCriterias: [selectedCriterias[currentIndex]],
              previousScreen: location.pathname,
              currentIndex: 0,
              paramsData,
            },
          ]);
        };
      }
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  useEffect(() => {
    setCurrentMode(baseMode);
  }, [baseMode]);

  useEffect(() => {
    const fetchInitialData = async () => {
      console.log("paramsData -> ", paramsData);
      console.log("selectedCriterias -> ", selectedCriterias);
      const url = isAddMode(currentMode)
        ? `api/aocaccumovrdscdcriteria/intial-form-data/${encodeURIComponent(
            paramsData.aosAccumOvrdSchedule
          )}`
        : `api/aocaccumovrdscdcriteria/${encodeURIComponent(
            selectedCriterias[currentIndex].aosAccumOvrdSchedule
          )}?sequenceNumber=${selectedCriterias[currentIndex].aocSeqNbr}`;

      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        console.log("initial data", responseData);
        isAddMode(mode)
          ? setInitialFormData({ ...responseData, ...paramsData })
          : setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };

    if (initialLookupMode && Object.keys(baseFormData).length) {
      setInitialFormData(baseFormData);
    } else {
      fetchInitialData();
    }
  }, [mode, currentIndex, initialLookupMode]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div
        className={`col col-12 ${classes.AccumulatorOverrideSceduleCriteriaForm}`}
      >
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          viewLookupDetails={viewLookupDetails}
          lookupData={lookupData}
        />
      </div>
    </div>
  );
};

export default AccumulatorOverrideScheduleCriteriaForm;
